/**
 * Created by Jie Gao on 7/30/2019.
 */
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {DragonTribeParsedGameData} from "../server/data/DragonTribeParsedGameData";
import {TimelineLite} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class FreespinNoWinPause extends ReelStopPresentationController {
    private _setPause:boolean = false;

    constructor(index:number) {
        super(index, "FreespinNoWinPause");
    }

    protected parseFeatureGameData(data:DragonTribeParsedGameData):void {
        this._setPause = ((data.mode === GameMode.FREESPIN) && data.avalancheTotalWin === 0)
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(data.reelId === 5) {
            new TimelineLite().add(() => {
                this.dispatchCompleteEvent(data.reelId);
            }, this._setPause ? 0.7 : 0);
        } else {
            this.dispatchCompleteEvent(data.reelId);
        }

    }
}